exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\n    position: relative;\n    width: 250px;\n    height: 135px;\n    overflow: hidden;\n    margin-left: 0;\n  }\n  .image {\n    border-radius: 4px;\n    width: 100%;\n    height: 100% !important;\n    transition: -webkit-transform 0.3s ease, -webkit-filter 0.3s ease;\n    transition: transform 0.3s ease, filter 0.3s ease;\n    transition: transform 0.3s ease, filter 0.3s ease, -webkit-transform 0.3s ease, -webkit-filter 0.3s ease;\n    -o-object-fit: cover;\n       object-fit: cover;\n    height: 100%;\n    width: 100%;\n  }\n  .zoom-icon {\n    position: absolute;\n    top: 50px;\n    right: 45%;\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n  }\n\n  .success {\n    float: left;\n    padding: 55px 0 !important;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 21px;\n    color: var(--success);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-common-module/scora-image-view/scora-image-view.component.css
// module id = 834
// module chunks = 6